<template>
  <b-modal
    centered
    ref="form-modal"
    v-model="editorShown"
    :title="
      formId ? 'Edit Insurance Company Plan' : 'Add Insurance Company Plan'
    "
    header-bg-variant="primary"
    header-text-variant="white"
    @ok="submitInsuranceCompanyPlan"
    no-close-on-backdrop
    size="md"
    header-class="bg-purple"
  >
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="secondary" @click="cancel()">
        Cancel
      </b-button>
      <b-button variant="primary" @click="ok()">
        Save
      </b-button>
    </template>
    <b-row>
      <b-col>
        <b-form-group
          label="Name"
          :state="formErrors.name.length == 0 ? null : false"
          :invalid-feedback="formErrors.name.join(', ')"
        >
          <template v-slot:label>
            Name <span class="text-danger">*</span>
          </template>
          <b-form-input v-model="form.name" maxLength="100"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import insuranceCompanyPlanServer from "../../server/insuranceCompanyPlan";
import { mapActions } from "vuex";
import { validateRequired } from "../../helpers/validation";

export default {
  name: "InsuranceCompanyPlanModal",
  props: ["formId"],
  data() {
    return {
      list: [],
      form: {
        name: ""
      },
      formErrors: {
        name: []
      }
    };
  },
  async mounted() {
    if (this.formId) {
      const form = await insuranceCompanyPlanServer.get(this.formId);
      this.form = {
        name: form.name
      };
    }
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    validateSubmitInsuranceCompanyPlan() {
      let withoutErrors = true;

      this.formErrors.name = [];
      if (!validateRequired(this.form.name)) {
        this.formErrors.name.push("This field is required");
        withoutErrors = false;
      }
      return withoutErrors;
    },
    async submitInsuranceCompanyPlan(modalEvent) {
      modalEvent.preventDefault();
      const result = this.validateSubmitInsuranceCompanyPlan();
      if (result) {
        const formData = {
          name: this.form.name
        };
        let insuranceCompanyPlan = {};
        if (this.formId) {
          await insuranceCompanyPlanServer.update(this.formId, formData);
        } else {
          insuranceCompanyPlan = await insuranceCompanyPlanServer.create(
            formData
          );
        }
        this.showAlertSuccess();
        this.$emit("onModify", { insuranceCompanyPlan });
        this.$refs["form-modal"].hide();
      }
    }
  },
  computed: {
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style scoped>
.section-title {
  margin-top: 25px;
  margin-bottom: 15px;
}
.section-body {
  min-height: 70px;
}
</style>
